import { Trabalho, TrabalhoApiResponse } from './trabalho.types';

export const mapperApiResponseToDomain = (apiResponse: TrabalhoApiResponse): Trabalho => {
  return {
    id: apiResponse.id,
    disciplina: apiResponse.disciplina,
    entregas: apiResponse.entregas,
    titulo: apiResponse.titulo,
    enunciado: apiResponse.enunciado,
    modelo: apiResponse.modelo,
    obrigatorio: apiResponse.obrigatorio,
    tipoTrabalho: apiResponse.tipoTrabalho,
    prazoEntrega: apiResponse.prazoEntrega ? new Date(apiResponse.prazoEntrega) : undefined,
    idPrazoTrabalho: apiResponse.idPrazoTrabalho,
    temResposta: apiResponse.temResposta,
    quantidadeMateriaisApoio: apiResponse.quantidadeMateriaisApoio,
    avaliacao: apiResponse.avaliacao,
    statusResposta: apiResponse.statusResposta,
    permitirEnvioForaPrazo: apiResponse.permitirEnvioForaPrazo,
    dataAtualizacao: apiResponse.dataAtualizacao ? new Date(apiResponse.dataAtualizacao) : undefined,
  };
};
